import {AnchorExternal, RsnButton, RsnDialog, RsnTextButton} from '@raison/ui-kit';
import classNames from 'classnames';
import React, {ComponentProps, FC} from 'react';
import {useNavigate} from 'react-router';
import buttonStyles from '~/shared/legacy_presentational-components/Rsn/buttons/lightblueButtonStyles/lightblueButtonStyles.module.scss';

export interface LoginErrorModalProps {
    userName?: string;
    title?: string;
    context?: string;
    code?: number;
    link?: string;
    type?: ComponentProps<typeof RsnDialog.StatusIcon>['status'];
}

export const LoginErrorModal: FC<LoginErrorModalProps> = ({link, userName, title, context, code, type = 'alert'}) => {
    const {onClose: closeAction} = RsnDialog.useControls();

    const navigate = useNavigate();

    const chooseContent = () => {
        if (code === 400 && !title?.includes('You need to wait a bit'))
            return title?.includes('Invalid password or phone number') ? (
                <>
                    <RsnDialog.CenteredHeader icon={{element: <RsnDialog.StatusIcon status={type} />}}>
                        {title} {userName}
                    </RsnDialog.CenteredHeader>
                    <RsnDialog.Body>
                        <span>Don&apos;t you have an account yet?</span>
                        <RsnTextButton.Block
                            onClick={() => {
                                navigate('/signup');
                            }}
                        >
                            Go to the registration
                        </RsnTextButton.Block>
                    </RsnDialog.Body>
                </>
            ) : (
                <>
                    <RsnDialog.CenteredHeader icon={{element: <RsnDialog.StatusIcon status={type} />}}>
                        {title}
                    </RsnDialog.CenteredHeader>
                    <RsnDialog.Body>
                        <div>If you have any questions, please get in touch with our support team.</div>
                        <RsnTextButton.Block
                            onClick={() => {
                                navigate('/support/form');
                            }}
                        >
                            Contact support
                        </RsnTextButton.Block>
                    </RsnDialog.Body>
                </>
            );
        else
            return (
                <>
                    <RsnDialog.CenteredHeader icon={{element: <RsnDialog.StatusIcon status={type} />}}>
                        {title}
                    </RsnDialog.CenteredHeader>
                    <RsnDialog.Body>{context}</RsnDialog.Body>
                    <RsnDialog.Footer>
                        {link ? (
                            <AnchorExternal href={link} className={buttonStyles.btn}>
                                Continue
                            </AnchorExternal>
                        ) : (
                            <RsnButton.Secondary
                                className={classNames(buttonStyles.btn, buttonStyles.lightBlueBckgr)}
                                onClick={closeAction}
                            >
                                I got it
                            </RsnButton.Secondary>
                        )}
                    </RsnDialog.Footer>
                </>
            );
    };

    return <RsnDialog.Window>{chooseContent()}</RsnDialog.Window>;
};
